import { render } from "./Sprints.vue?vue&type=template&id=184af9d5&scoped=true"
import script from "./Sprints.vue?vue&type=script&lang=js"
export * from "./Sprints.vue?vue&type=script&lang=js"

import "./Sprints.vue?vue&type=style&index=0&id=184af9d5&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184af9d5"]])

export default __exports__